import "./styles.scss";

const Spinner = ({ fullpage }) => {
  return (
    <div className={fullpage ? "spinner-fullpage" : "spinner"}>
      <span />
    </div>
  );
};

export default Spinner;
